import { IVariantClassificationListParams, VariantClassificationState } from '../types';

// This is a separate constant (not a part of the VariantClassificationState enum)
// because it's not a true state on the Variant Classification model's FSM
export const VariantClassificationStateAllOption = 'all';

// This comes from the old Angular code
// TODO: [UV-2951] We should ask our stakeholders if
// we can rename the values to fit the actual states in the database

export enum VariantClassificationClinicalDomain {
  ALL = 'all',
  CANCER = 'cancer',
  CARDIO = 'cardio',
  OTHER = 'other',
}

export enum VariantClassificationVariants {
  ALL = 'all',
  CALLED = 'called',
  IN_REPORTS = 'in_reports',
}

export enum VariantClassificationReadyForReview {
  INTERNAL = 'internal',
  EXTERNAL = 'external',
}

export const DEFAULT_VARIANT_CLASSIFICATION_SEARCH_PARAMS: IVariantClassificationListParams = {
  state: VariantClassificationState.NEW,
  clinicalDomain: VariantClassificationClinicalDomain.ALL,
  variants: VariantClassificationVariants.IN_REPORTS,
  kitBarcode: '',
  batchId: '',
  nomenclature: '',
  gene: '',
  exon: '',
  vepConsequence: '',
  classification: '',
  readyForReview: '',
  orderBy: '',
  orderDirection: '',
};

export enum VariantClassificationField {
  // These fields are arbitrarily named, following React conventions
  ID = 'id',
  PRIORITY = 'priority',
  EXON = 'exon',

  // Fields are used for sorting, and have set names from ordering_fields in VariantClassificationViewSet
  // from monoweb/django_apps/variant_classifications/views.py. Updating these fields would break the sorting
  // functionality of DataGrid
  CREATED = 'created_at',
  INTERPRETED = 'interpreted_at',
  UPDATED = 'updated_at',
  LAST_REVIEWED = 'last_reviewed_at',
  REVIEWED = 'reviewed_at',
  PRIORITY_DATE = 'classification_unit__priority_date',
  GENE = 'classification_unit__variant__gene',
  VARIANT = 'classification_unit__variant__pos',
  MEDIAN_ALLELE_FRACTION = 'classification_unit__variant__allele_fraction_summary__median',
  EFFECT = 'classification_unit__effect',
  CLASSIFICATION = 'classification__short_name',
  STATE = 'state',
}

export const STATE_OPTION_TO_DEFAULT_ORDERING_FIELD: Record<
  VariantClassificationState & 'all',
  VariantClassificationField
> = {
  [VariantClassificationState.NEW]: VariantClassificationField.CREATED,
  [VariantClassificationState.REREVIEW]: VariantClassificationField.LAST_REVIEWED,
  [VariantClassificationState.IN_PROGRESS]: VariantClassificationField.UPDATED,
  [VariantClassificationState.INTERPRETED]: VariantClassificationField.INTERPRETED, // Reviewable
  [VariantClassificationState.REVIEWED]: VariantClassificationField.REVIEWED, // Classified
  all: VariantClassificationField.CREATED,
};
